export function cordovaPostMessage(message) {
  const data = JSON.stringify(message);
  window.webkit.messageHandlers.cordova_iab.postMessage(data);
}
